import { render } from "./BaseHeaderNav.vue?vue&type=template&id=eded8316&scoped=true"
import script from "./BaseHeaderNav.vue?vue&type=script&lang=js"
export * from "./BaseHeaderNav.vue?vue&type=script&lang=js"

import "./BaseHeaderNav.vue?vue&type=style&index=0&id=eded8316&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eded8316"]])

export default __exports__